import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { IconButton, Tooltip } from '@mui/material';
import { isEnabledModule } from '#component/project/form/helper';
import DisabledModuleMessage from '#component/project/form/project/project-modules/disabled-module-message';
import {
  AddButtonContainer,
  AddButtonIcon,
  ButtonContainer,
  StyledButton,
  StyledPaper,
  StyledTitle
} from './styles';
import RenderCustomFields from './render-custom-fields';
import { useIntersection } from '#hooks';
import { uuidv4 } from '#helper';

const intersectionOptions = {
  rootMargin: '-69px',
  threshold: [1]
};

const CustomFieldsForm = props => {
  const {
    submitting,
    previousStep,
    nextStep,
    history,
    forceError,
    formModules,
    submitForm,
    saveDisabled
  } = props;
  const { sentinelRef, isIntersecting } = useIntersection(intersectionOptions);
  const { control, handleSubmit } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'customFields',
    keyName: 'fieldId'
  });
  const shipmentModuleEnabled = isEnabledModule('SHIPMENT', formModules);

  const handleCancelClick = () => {
    history.push('/project');
  };

  const addNewCustomField = handleSubmit(() => append({ id: uuidv4() }));

  return (
    <form onSubmit={submitForm} autoComplete="off">
      {shipmentModuleEnabled ?
        <>
          <StyledTitle variant="h4" gutterBottom>
            Custom fields
          </StyledTitle>
          <StyledPaper elevation={0}>
            <RenderCustomFields
              fields={fields}
              remove={remove}
              forceError={forceError}
            />
          </StyledPaper>
        </> : <DisabledModuleMessage />}
      <div ref={sentinelRef} />
      <ButtonContainer
        isIntersecting={isIntersecting}
        shipmentModuleEnabled={shipmentModuleEnabled}
      >
        {shipmentModuleEnabled ?
          <AddButtonContainer>
            <IconButton
              size="small"
              onClick={addNewCustomField}
              aria-label="Add custom field"
            >
              <Tooltip title="Add custom field">
                <AddButtonIcon />
              </Tooltip>
            </IconButton>
          </AddButtonContainer> : null}
        <div>
          <StyledButton variant="outlined" onClick={handleCancelClick}>
            Cancel
          </StyledButton>
          <StyledButton
            variant="outlined"
            onClick={previousStep}
          >
            Back
          </StyledButton>
          <StyledButton
            disabled={submitting}
            onClick={nextStep}
            variant="outlined"
          >
            Next
          </StyledButton>
          <StyledButton
            disabled={saveDisabled}
            type="submit"
            variant="contained"
            color="secondary"
          >
            Save
          </StyledButton>
        </div>
      </ButtonContainer>
    </form>
  );
};

export default CustomFieldsForm;
